import React from "react";
import {
  Box,
  Flex,
  Heading,
  Text,
  Button,
  useColorMode,
  Icon,
  VStack,
  Container,
  useColorModeValue,
  IconButton,
  HStack,
  Badge,
} from "@chakra-ui/react";
import { MoonIcon, SunIcon } from "@chakra-ui/icons";
import { BsTools, BsRocket, BsClock } from "react-icons/bs";

export default function ComingSoon() {
  const { colorMode, toggleColorMode } = useColorMode();

  // Color mode values
  const bg = useColorModeValue("gray.50", "gray.900");
  const cardBg = useColorModeValue("white", "gray.800");
  const textColor = useColorModeValue("gray.600", "gray.300");
  const headingColor = useColorModeValue("teal.600", "teal.300");
  const accentColor = useColorModeValue("teal.500", "teal.300");
  const badgeBg = useColorModeValue("teal.100", "teal.900");
  const badgeColor = useColorModeValue("teal.800", "teal.100");

  const features = [
    {
      icon: BsRocket,
      title: "Innovation",
      description: "Cutting-edge solutions for modern business needs",
    },
    {
      icon: BsTools,
      title: "Customization",
      description: "Tailored to fit your specific requirements",
    },
    {
      icon: BsClock,
      title: "Efficiency",
      description: "Streamlined processes to save time and resources",
    },
  ];

  return (
    <Box minH="100vh" bg={bg} position="relative">
      {/* Color Mode Toggle */}
      <IconButton
        icon={colorMode === "light" ? <MoonIcon /> : <SunIcon />}
        onClick={toggleColorMode}
        position="absolute"
        top={4}
        right={4}
        variant="ghost"
        aria-label="Toggle color mode"
      />

      <Container maxW="container.xl" py={20}>
        <VStack spacing={10} align="center">
          {/* Main Heading Section */}
          <VStack spacing={6} textAlign="center" maxW="800px">
            <Badge
              fontSize="md"
              px={4}
              py={2}
              bg={badgeBg}
              color={badgeColor}
              rounded="full"
            >
              Coming Soon
            </Badge>

            <Heading
              size="2xl"
              bgGradient="linear(to-r, teal.400, teal.600)"
              bgClip="text"
              letterSpacing="tight"
            >
              Welcome to Novatra
            </Heading>

            <Text fontSize="xl" color={textColor} lineHeight="tall">
              We're crafting something special to revolutionize your business
              operations. This feature is currently under development and will
              be available soon.
            </Text>
          </VStack>

          {/* Features Grid */}
          <Flex wrap="wrap" justify="center" gap={8} mt={12}>
            {features.map((feature, index) => (
              <Box
                key={index}
                bg={cardBg}
                p={8}
                rounded="xl"
                shadow="lg"
                maxW="sm"
                borderWidth="1px"
                borderColor={useColorModeValue("gray.200", "gray.700")}
                transition="all 0.3s"
                _hover={{
                  transform: "translateY(-5px)",
                  shadow: "xl",
                  borderColor: accentColor,
                }}
              >
                <VStack spacing={4} align="center" textAlign="center">
                  <Icon as={feature.icon} boxSize={8} color={accentColor} />
                  <Heading size="md" color={headingColor}>
                    {feature.title}
                  </Heading>
                  <Text color={textColor}>{feature.description}</Text>
                </VStack>
              </Box>
            ))}
          </Flex>

          {/* Call to Action */}
          <VStack spacing={4} mt={12}>
            <Button
              colorScheme="teal"
              size="lg"
              px={8}
              rounded="full"
              fontSize="md"
              fontWeight="bold"
              _hover={{
                transform: "translateY(-2px)",
                boxShadow: "lg",
              }}
            >
              Notify Me When Ready
            </Button>
            <Text fontSize="sm" color={textColor}>
              We'll let you know as soon as this feature is available
            </Text>
          </VStack>
        </VStack>
      </Container>
    </Box>
  );
}
